<template>
    <div class="nav-tabs-custom nav-tabs-custom-dynamic">
        <ul
            :class="{ disabled: disabledDynamicFilter }"
            class="nav nav-tabs"
            @click.prevent.stop="!disabledDynamicFilter"
        >
            <li
                v-for="value in tabs"
                :key="value.id"
                :class="{ active: value.active }"
                @click="!disabledDynamicFilter && setActive(value.id)"
            >
                <a
                    :href="'#' + value.id"
                    aria-expanded="true"
                    class="custom-link"
                    data-toggle="tab"
                    >{{ value.name }}</a
                >
                <div class="control-tab">
                    <span
                        class="close-tab"
                        @click.stop="!disabledDynamicFilter && closeTab(value.id)"
                    >
                        <i class="fa fa-close"></i>
                    </span>
                </div>
            </li>
            <li
                class="add-new-tab"
                @click="!disabledDynamicFilter && newTab()"
            >
                <i class="fa fa-plus"></i>
            </li>
        </ul>
        <div class="tab-content tab-content--background">
            <div
                v-for="value in tabs"
                :id="value.id"
                :key="value.id"
                :class="{ active: value.active }"
                class="tab-pane table-responsive"
            >
                <clicker-report-filters
                    ref="filters"
                    :count="value.count"
                    :data-items="dataMainItems"
                    :disabled-dynamic-filter="disabledDynamicFilter"
                    :external-params="value.externalParams"
                    :id-tab="value.id"
                    @changeFilterParameter="changeFilterParameter"
                    @sendForm="sendForm"
                    @setDisabledDynamicFilter="setDisabledDynamicFilter"
                    @setMainItems="setMainItems"
                />
            </div>
        </div>
    </div>
</template>

<script>
import LZString from 'lz-string';
import ClickerReportFilters from './ClickerReportFiltersComponent';

export default {
    components: {
        ClickerReportFilters,
    },
    data: function () {
        return {
            tabs: [],
            dataMainItems: [],
            disabledDynamicFilter: false,
            countLoadedTab: 0,
            loadedTabs: false,
            disabledDynamicFilterItems: [],
        };
    },
    mounted() {
        this.loadTabsByParams();
    },
    methods: {
        newTab(data) {
            let lastTab = this.tabs.slice(-1).pop();
            let count = lastTab && lastTab.count ? lastTab.count + 1 : 1;
            let item = {
                id: 'tab_' + count,
                count: count,
                active: count === 1,
                name: 'Report #' + count,
                externalParams: data || null,
            };
            this.tabs.push(item);
        },
        closeTab(id) {
            let self = this;
            self.tabs.forEach(function (item, index) {
                if (item.id === id && item.active === true) {
                    if (self.tabs[index - 1]) {
                        self.tabs[index - 1].active = true;
                    } else if (self.tabs[index + 1]) {
                        self.tabs[index + 1].active = true;
                    }
                }
            });
            self.tabs = self.tabs.filter(function (item) {
                return item.id !== id;
            });
            this.changeFilterParameter();
        },
        setActive(id) {
            this.tabs.map(function (value) {
                value.active = value.id === id;
                return value;
            });
        },
        sendForm(statusSend) {
            this.$refs.filters.map(function (val) {
                val.sending = statusSend;
            });
        },
        setMainItems(data, id) {
            this.dataMainItems[id] = data;
        },
        setDisabledDynamicFilter(allDataLoaded) {
            this.disabledDynamicFilter = !(!allDataLoaded && this.loadedTabs);
            if (!allDataLoaded && !this.loadedTabs) {
                this.loadTabsByParams();
            } else {
                this.sendForm(false);
            }
        },
        loadTabsByParams() {
            let params = this.$route.query.key && this.$route.query.key.length > 0 ? JSON.parse(LZString.decompressFromEncodedURIComponent(this.$route.query.key)) : null;

            // Generate new tab
            if (params) {
                params[this.countLoadedTab] && this.newTab(params[this.countLoadedTab]);
                this.countLoadedTab++;
                !params[this.countLoadedTab] && (this.loadedTabs = true);
            } else {
                this.newTab();
                this.loadedTabs = true;
            }
        },
        changeFilterParameter() {
            if (!this.loadedTabs) {
                return false;
            }
            let self = this;
            let params = [];
            self.tabs.forEach(function (tabValue, indexTab) {
                self.$refs.filters.forEach(function (filterVal) {
                    if (tabValue.id === filterVal.idTab) {
                        let itemParams = {};
                        filterVal.formItems.forEach(function (itemVal) {
                            let currentRef = filterVal.getCurrentRef(itemVal.id);
                            if (currentRef) {
                                let valueRef = currentRef.getValue();
                                if (valueRef !== null) {
                                    itemParams[itemVal.id] = valueRef;
                                }
                            }
                        });

                        if (self.tabs.length > 1 || (indexTab === 0 && ((!self.isDefaultParams(itemParams) && !self.isEmptyObject(itemParams)) || tabValue.manualName))) {
                            params.push(itemParams);
                        }
                    }
                });
            });
            params = params.length > 0 ? { key: LZString.compressToEncodedURIComponent(JSON.stringify(params)) } : '';
            self.pushToRoute(params);
        },
        pushToRoute(params) {
            this.$router
                .push({
                    path: this.$route.path,
                    query: params,
                    name: 'clicker.report',
                })
                .catch(() => {});
        },
        isDefaultParams(itemParams) {
            return (
                Object.keys(itemParams).length <= 4 && (!itemParams.filter || itemParams.filter.length === 0) && (!itemParams.reportBy || itemParams.reportBy === 'contact') && !itemParams.clearCache
            );
        },
        isEmptyObject(obj) {
            for (let i in obj) {
                if (Object.prototype.hasOwnProperty.call(obj, i)) {
                    return false;
                }
            }
            return true;
        },
    },
};
</script>
